import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";

import { DataTable } from "capitalrx-components";
import { queryString } from "capitalrx-utilities";

import { pharmacySearchActions } from "@/App/actions";
import { RootState } from "@/App/reducers";
import { PharmacyTypes } from "@/types";

import tableHeaders from "./listTableHeaders";

import { logEvent, ANALYTIC_EVENTS } from "@/App/utils/analytics";

const FORM_NAME = "PharmacySearchForm";

const PharmacySearchResultsTable: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { search } = useLocation();

  const { results, result_count } = useSelector((state: RootState) => state.pharmacySearch.pharmacySearchResults);
  const { pharmacySearchOptions } = useSelector((state: RootState) => state.pharmacySearch);
  const { PharmacySearchForm } = useSelector((state: RootState) => state.form);
  const { searchForPharmacy } = pharmacySearchActions;

  let submitting = false;
  if (PharmacySearchForm && PharmacySearchForm.submitting) {
    submitting = PharmacySearchForm.submitting;
  }

  const handleUpdate = (data: PharmacyTypes.PharmacySearchOptions): void => {
    dispatch(
      searchForPharmacy({
        data,
        formName: FORM_NAME,
      }),
    );
  };

  const handleClick = (e: { npi: string }): void => {
    // preserve the existing URL parameters
    const queryParams = queryString.getQueryParams(search);
    queryParams.npi = e.npi;
    const paramsString = queryString.convertJsonToQueryString(queryParams);

    const finalPath = "/manual-claim?" + paramsString;

    navigate(finalPath);

    logEvent(ANALYTIC_EVENTS.MANUAL_CLAIM_PHARMACY.add);
  };

  const tableResultHeader = `${result_count} ${result_count === "1" ? "pharmacy" : "pharmacies"} found:`;

  const pharmacyList: Array<PharmacyTypes.Pharmacy> = results.map(({ pharmacy }) => pharmacy);

  let resultsTable = null;
  if (result_count) {
    resultsTable = (
      <>
        <div className="table-section-result-header">{tableResultHeader}</div>
        <DataTable
          searchIsEnabled={false}
          data={pharmacyList}
          headers={tableHeaders}
          onClick={handleClick}
          queryOptions={pharmacySearchOptions}
          isLoading={submitting}
          resultsTotalCount={result_count}
          handleUpdateRequest={handleUpdate}
          className="search-list"
        />
      </>
    );
  }

  return resultsTable;
};

export default PharmacySearchResultsTable;
